export default __webpack_public_path__ + "static/googleLogo2-7034e8f2ce9a40f143fdc8c8a5e142ea.png";